import React from "react";
import * as XLSX from "xlsx";
import ImportadorExcelGenerico from "../../../../../Components/ImportadorExcelGenerico";

const columnasPreview = [
  { title: "Clave", dataIndex: "clave", key: "clave", width: 110 },
  { title: "Nombre", dataIndex: "nombre", key: "nombre", width: 240 },
  {
    title: "Descripción",
    dataIndex: "descripcion",
    key: "descripcion",
    width: 260,
    ellipsis: true,
  },
  {
    title: "Tipo de Cliente",
    dataIndex: "tipoDeClienteNombre",
    key: "tipoDeClienteNombre",
    width: 200,
  },
];

const construirPlantilla = (catalogos) => {
  const wb = XLSX.utils.book_new();

  const tipoEjemplo =
    (catalogos.tiposCliente && catalogos.tiposCliente[0]?.nombre) || "";

  const ejemplos = [
    {
      Clave: "ESC001",
      Nombre: "Colegio Ejemplo",
      Descripción: "Plantel principal",
      "Tipo de Cliente": tipoEjemplo,
    },
  ];
  const hojaPrincipal = XLSX.utils.json_to_sheet(ejemplos, {
    header: ["Clave", "Nombre", "Descripción", "Tipo de Cliente"],
  });
  hojaPrincipal["!cols"] = [
    { wch: 12 },
    { wch: 30 },
    { wch: 40 },
    { wch: 28 },
  ];
  XLSX.utils.book_append_sheet(wb, hojaPrincipal, "Escuelas");

  const tiposClienteFilas = (catalogos.tiposCliente || []).map((t) => ({
    Nombre: t.nombre,
  }));
  const hojaTiposCliente =
    tiposClienteFilas.length > 0
      ? XLSX.utils.json_to_sheet(tiposClienteFilas)
      : XLSX.utils.json_to_sheet([
          { Nombre: "(no hay tipos de cliente activos)" },
        ]);
  hojaTiposCliente["!cols"] = [{ wch: 32 }];
  XLSX.utils.book_append_sheet(wb, hojaTiposCliente, "Tipos de Cliente");

  const existentes = (catalogos.escuelas || []).map((e) => ({
    Clave: e.clave || "",
    Nombre: e.nombre,
    Estado: e.estado === 1 ? "Activo" : "Deshabilitado",
  }));
  const hojaExistentes =
    existentes.length > 0
      ? XLSX.utils.json_to_sheet(existentes)
      : XLSX.utils.json_to_sheet([{ Nombre: "(no hay escuelas registradas)" }]);
  hojaExistentes["!cols"] = [{ wch: 12 }, { wch: 32 }, { wch: 16 }];
  XLSX.utils.book_append_sheet(wb, hojaExistentes, "Existentes");

  return wb;
};

const validarFila = (fila, catalogos, _indice, contexto) => {
  const errores = [];
  const nombre = fila["Nombre"] ? String(fila["Nombre"]).trim() : "";
  const clave = fila["Clave"] ? String(fila["Clave"]).trim() : "";
  const descripcion = fila["Descripción"]
    ? String(fila["Descripción"]).trim()
    : fila["Descripcion"]
      ? String(fila["Descripcion"]).trim()
      : "";
  const tipoCliente = fila["Tipo de Cliente"]
    ? String(fila["Tipo de Cliente"]).trim()
    : "";

  if (!nombre) errores.push({ campo: "Nombre", motivo: "está vacío" });
  if (!tipoCliente)
    errores.push({ campo: "Tipo de Cliente", motivo: "está vacío" });

  if (nombre) {
    const llaveNombre = nombre.toLowerCase();
    const existeNombre = (catalogos.escuelas || []).some(
      (e) => (e.nombre || "").trim().toLowerCase() === llaveNombre,
    );
    if (existeNombre) {
      errores.push({
        campo: "Nombre",
        motivo: "ya existe una escuela con ese nombre",
      });
    }

    if (contexto.clavesYaUsadas.has("nombre:" + llaveNombre)) {
      errores.push({
        campo: "Nombre",
        motivo: `nombre repetido en el archivo (también está en la fila ${contexto.clavesYaUsadas.get("nombre:" + llaveNombre)})`,
      });
    } else {
      contexto.clavesYaUsadas.set(
        "nombre:" + llaveNombre,
        (fila["__rowNum__"] ?? 0) + 1,
      );
    }
  }

  if (clave) {
    const llaveClave = clave.toLowerCase();
    const existeClave = (catalogos.escuelas || []).some(
      (e) => (e.clave || "").trim().toLowerCase() === llaveClave,
    );
    if (existeClave) {
      errores.push({
        campo: "Clave",
        motivo: "ya existe una escuela con esa clave",
      });
    }

    if (contexto.clavesYaUsadas.has("clave:" + llaveClave)) {
      errores.push({
        campo: "Clave",
        motivo: `clave repetida en el archivo (también está en la fila ${contexto.clavesYaUsadas.get("clave:" + llaveClave)})`,
      });
    } else {
      contexto.clavesYaUsadas.set(
        "clave:" + llaveClave,
        (fila["__rowNum__"] ?? 0) + 1,
      );
    }
  }

  let tipoDeClienteId = null;
  let tipoDeClienteNombreResuelto = tipoCliente;
  if (tipoCliente) {
    const llaveTipo = tipoCliente.toLowerCase();
    const tipo = (catalogos.tiposCliente || []).find(
      (t) => (t.nombre || "").trim().toLowerCase() === llaveTipo,
    );
    if (!tipo) {
      errores.push({
        campo: "Tipo de Cliente",
        motivo: `"${tipoCliente}" no existe (revisa la hoja "Tipos de Cliente")`,
      });
    } else {
      tipoDeClienteId = tipo._id;
      tipoDeClienteNombreResuelto = tipo.nombre;
    }
  }

  if (errores.length > 0) {
    return { ok: false, errores };
  }

  return {
    ok: true,
    datos: {
      nombre,
      clave,
      descripcion,
      tipoDeClienteId,
      tipoDeClienteNombre: tipoDeClienteNombreResuelto,
    },
  };
};

const ImportarEscuelas = (props) => (
  <ImportadorExcelGenerico
    {...props}
    titulo="Importar Escuelas"
    nombreEntidadPlural="escuelas"
    endpointDatosImportar="escuelas/datosParaImportarEscuelas"
    endpointImportar="escuelas/importarEscuelas"
    nombrePlantilla="plantillaEscuelas.xlsx"
    construirPlantilla={construirPlantilla}
    validarFila={validarFila}
    columnasPreview={columnasPreview}
  />
);

export default ImportarEscuelas;
